<template>
  <div class="questionAsk">
    <div
      class="questionAskTitle"
      id="questionAskTitle"
      v-html="datas.questionDetail.name.replace(/\n/g, '<br>')"
    ></div>
    <div class="questionAskTitleFd"></div>
    <div class="audioDiv" v-if="isAudio">
      <audio
        class="sourceAudio"
        controls="controls"
        v-for="(itemAudio, indexAudio) in datas.questionDetail.audioPath"
        :key="indexAudio"
      >
        <source :src="itemAudio" type="audio/ogg" />
        Your browser does not support the audio element.
      </audio>
    </div>
    <div
      class="questionAskCenter"
      v-for="(item, index) in datas.doTopicDTOS"
      :key="index"
    >
      <!--      单选题-->
      <ChoiceOne
        v-if="item.questionType === '单选题样式'"
        :isAnalysis="isAnalysis || $route.query.topicLx === 'topicLx'"
        :index="topicLx ? index + 1 : item.topicNum"
        :datas="item"
        :isDisabled="isDisabled"
        @showAnalysis="showAnalysisCl"
      />
      <!--      填空题-->
      <FillBlank
        v-if="item.questionType === '填空题样式'"
        :isAnalysis="isAnalysis || $route.query.topicLx === 'topicLx'"
        :index="topicLx ? index + 1 : item.topicNum"
        :datas="item"
        :isDisabled="isDisabled"
        @showAnalysis="showAnalysisCl"
      />
      <!--      判断题-->
      <Judge
        v-if="
          item.questionType === '判断题样式' ||
          item.questionType === '阅读判断题样式'
        "
        :isAnalysis="isAnalysis || $route.query.topicLx === 'topicLx'"
        :index="topicLx ? index + 1 : item.topicNum"
        :datas="item"
        :isDisabled="isDisabled"
        @showAnalysis="showAnalysisCl"
      />
      <!--      多选题-->
      <ChoiceMultiple
        v-if="item.questionType === '多选题样式'"
        :isAnalysis="isAnalysis || $route.query.topicLx === 'topicLx'"
        :index="topicLx ? index + 1 : item.topicNum"
        :datas="item"
        :isDisabled="isDisabled"
        @showAnalysis="showAnalysisCl"
      />
      <!--      简答题-->
      <Subjective
        v-if="item.questionType === '简答题样式'"
        :isAnalysis="isAnalysis || $route.query.topicLx === 'topicLx'"
        :index="topicLx ? index + 1 : item.topicNum"
        :datas="item"
        :isDisabled="isDisabled"
        @showAnalysis="showAnalysisCl"
      />
      <!-- 解析 -->
      <QuestionAnalysis
        ref="questionAnalysis"
        v-show="isAnalysisDt || showAnalysisAsy === item.id"
        :analysisDatas="item"
      />
    </div>
  </div>
</template>

<script>
import ChoiceOne from "./questionChoiceOne";
import FillBlank from "./questionFillBlank";
import Judge from "./questionJudge";
import ChoiceMultiple from "./questionChoiceMultiple";
import Subjective from "./questionSubjective";
import QuestionAnalysis from "./questionAnalysis";
import { questionMixin } from "./common.js";
export default {
  name: "questionAsk",
  mixins: [questionMixin],
  props: ["scrollTop"],
  components: {
    ChoiceOne,
    FillBlank,
    Judge,
    ChoiceMultiple,
    Subjective,
    QuestionAnalysis,
  },
  data() {
    return {
      showAnalysisAsy: "",
      analysisDatasOb: {},
      topicLx: "",
    };
  },
  created() {
    this.topicLx = this.$route.query.topicLx;
    this.getTitleInformation(this.datas);
  },
  methods: {
    onScroll() {
      console.log(123);
      // const _article = document.querySelectorAll(".questionAskCenter");
      // datas.doTopicDTOS.forEach((val, index) => {
      //   if (val.id === id) {
      //     if (index === 0) {
      //       this.$emit("viewScroll", 0);
      //     } else {
      //       this.$emit("viewScroll", _article[index].offsetTop - 300);
      //     }
      //   }
      // });
    },
    showAnalysisCl(id) {
      this.showAnalysisAsy = id;
    },
    getTitleInformation(data) {
      const datas = data.doTopicDTOS.map((item) => {
        if (
          item.questionType !== "填空题样式" &&
          item.questionType !== "简答题样式"
        ) {
          item.studentAnswerList = item.studentAnswerList.map((item2) => {
            return typeof item2 === "object" ? JSON.stringify(item2) : item2;
          });
        } else {
          item.studentAnswerList =
            item.studentAnswerList.length > 0
              ? item.studentAnswerList
              : item.answerList;
        }
        return item;
      });
      this.datas.topicList = datas;
    },
  },
};
</script>

<style scoped>
.questionAsk {
  position: relative;
}
/*.questionAskTitleFd{width: 100px;height: 60px;background-color: #fff;position: fixed;right: 333px;top: 300px;box-shadow: 0 0 10px rgba(0,0,0,0.2)}*/
.questionAskTitle {
  width: 100%;
  padding: 20px;
  background-color: #f8f8f8;
  text-indent: 2em;
  line-height: 26px;
  color: #333;
  margin-top: 48px;
  word-break: break-word;
}
.audioDiv {
  display: inline-block;
}
.audioDiv .sourceAudio {
  width: 300px;
  margin: 20px;
}
</style>
